<template>
  <div id="app">
    <meta name="referrer" content="no-referrer">
    <template v-if="!hideChrome">
      <header style="position: absolute;z-index: 1000;width: 100%;">
        <navHeader ref="navHeader" />
      </header>
      <div style="width:100%;height: 100px;background-color: #ffffff;" />
      <router-view />
      <indexFooter />
    </template>
    <div v-else class="ats-app-shell">
      <AtsViewportScale>
        <AtsSiteNav
          :active-nav-id="atsNavId"
          :page="atsPage"
          overlay
        />
        <div class="ats-app-shell__main">
          <keep-alive :include="atsKeepAliveIncludes">
            <transition name="ats-page" appear>
              <router-view :key="$route.path" class="ats-page-view" />
            </transition>
          </keep-alive>
        </div>
      </AtsViewportScale>
    </div>
  </div>
</template>

<script>
import navHeader from '@/components/indexHeader'
import indexFooter from '@/components/indexFooter'
import AtsSiteNav from '@/components/ats/AtsSiteNav.vue'
import AtsViewportScale from '@/components/ats/AtsViewportScale.vue'
import { applyRootPageZoom, clearRootPageZoom } from '@/util/pageScale'

/** @type {string[]} ATS 专题页 keep-alive 组件名 */
const ATS_KEEP_ALIVE_INCLUDES = [
  'AboutTheSavior',
  'GlobalRescue',
  'RescueListPage',
  'HealthMonitoringPage',
  'FirstAidKitPage',
  'CompanyIntroPage'
]

export default {
  name: 'App',
  components: {
    navHeader,
    indexFooter,
    AtsSiteNav,
    AtsViewportScale
  },
  computed: {
    /**
     * 全屏落地页（自带顶栏/底栏）时隐藏站点公共头尾
     * @returns {boolean}
     */
    hideChrome () {
      return !!(this.$route.meta && this.$route.meta.hideLayout)
    },
    /** @returns {string} */
    atsPage () {
      return (this.$route.meta && this.$route.meta.atsPage) || 'savior'
    },
    /** @returns {string} */
    atsNavId () {
      return (this.$route.meta && this.$route.meta.atsNavId) || 'about'
    },
    /** @returns {string[]} */
    atsKeepAliveIncludes () {
      return ATS_KEEP_ALIVE_INCLUDES
    }
  },
  watch: {
    hideChrome: {
      immediate: true,
      handler (isAts) {
        if (isAts) {
          clearRootPageZoom()
        } else {
          applyRootPageZoom()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.el-carousel__container {
  height: 26.041666vw;
}
</style>

<style scoped>
.ats-app-shell {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #0c1824;
  overflow-x: hidden;
}

.ats-app-shell__main {
  position: relative;
  min-height: 100vh;
}

.ats-page-view {
  width: 1920px;
  min-height: 100vh;
}

/* 交叉淡入淡出：新页先渲染在底层，旧页叠在上方渐隐，避免 out-in 中间空白闪屏 */
.ats-page-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  pointer-events: none;
}

.ats-page-enter-active {
  z-index: 1;
}

/* 菜单切换：淡出 + 轻微上移 → 淡入 + 归位 */
.ats-page-enter-active,
.ats-page-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.ats-page-enter {
  opacity: 0;
  transform: translateY(10px);
}

.ats-page-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.ats-page-enter-to,
.ats-page-leave {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .ats-page-enter-active,
  .ats-page-leave-active {
    transition: opacity 0.1s ease;
  }

  .ats-page-enter,
  .ats-page-leave-to {
    transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue